import React, {useState, useEffect} from 'react';

import Modal from 'react-bootstrap/Modal';

const ChangeBizApp = ({ serviceAppList, bizApp, callback }) => {
    const [show, setShow] = useState(false);
    const [bizApps, setBizApps] = useState(bizApp || []);

    useEffect(() => {
        setBizApps(bizApp);
        return () => {};
    }, [bizApp]);

    const checkboxHandler = (e) => {
        const { checked, name, value } = e.target;
        let _apps = [...bizApps];
        if (checked) {
            _apps.push(value);
        } else {
            _apps = _apps.filter((a) => value != a);
        }
        setBizApps(_apps);
    };

    return (
        <>
            <button className="float-right btn btn-sm btn-outline-danger btn-rounded ml-3" onClick={() => setShow(true)}>
                수정
            </button>
            <Modal show={show} onHide={() => setShow(false)} aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">계약 권한 부여</Modal.Title>
                </Modal.Header>
                <Modal.Body className="">
                    <p>해당 지사에서 계약 가능한 상품에 모두 체크 후 적용 버튼을 눌러 주세요.</p>
                    <div className="pl-3">
						{serviceAppList && serviceAppList.map((sa) => {
							if(sa.canContract) {
								return (
									<div key={`service-app-checkbox-${sa.key}`} className="custom-control custom-checkbox">
										<input
											type="checkbox"
											className="custom-control-input"
											id={`app_${sa.key}`}
											value={sa.key}
											name="apps"
											checked={bizApps.indexOf(sa.key) >= 0}
											onChange={checkboxHandler}
										/>
										<label className="custom-control-label" htmlFor={`app_${sa.key}`}>
											{sa.name}
										</label>
									</div>);
							} else {
								return null;
							}			
						})}
                    </div>
                </Modal.Body>
                <Modal.Footer className="p-0">
                    <button
                        className="btn btn-block btn-primary"
                        disabled={bizApps.length === 0}
                        onClick={() => {
                            callback(bizApps);
                            setShow(0);
                        }}
                    >
                        적용
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ChangeBizApp;